(function () {
  const VIEWPORT_MARGIN = 16;

  function positionTooltip(tip) {
    const tooltip = tip.querySelector('.whats-inside__tooltip');
    if (!tooltip) return;

    tooltip.style.setProperty('--wi-tooltip-shift', '0px');

    const rect = tooltip.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    let shift = 0;

    if (rect.right > viewportWidth - VIEWPORT_MARGIN) {
      shift = viewportWidth - VIEWPORT_MARGIN - rect.right;
    } else if (rect.left < VIEWPORT_MARGIN) {
      shift = VIEWPORT_MARGIN - rect.left;
    }

    tooltip.style.setProperty('--wi-tooltip-shift', `${Math.round(shift)}px`);
  }

  function closeAll(except) {
    document.querySelectorAll('.whats-inside__tip.is-open').forEach((tip) => {
      if (tip !== except) tip.classList.remove('is-open');
    });
  }

  function onPointerOver(event) {
    const tip = event.target.closest?.('.whats-inside__tip');
    if (!tip || tip.dataset.tooltipPositioned === 'true') return;

    tip.dataset.tooltipPositioned = 'true';
    positionTooltip(tip);
  }

  function onPointerOut(event) {
    const tip = event.target.closest?.('.whats-inside__tip');
    if (tip && !tip.contains(event.relatedTarget)) {
      delete tip.dataset.tooltipPositioned;
    }
  }

  function onFocusIn(event) {
    const tip = event.target.closest?.('.whats-inside__tip');
    if (!tip) return;
    positionTooltip(tip);
  }

  function onClick(event) {
    const tip = event.target.closest?.('.whats-inside__tip');
    if (!tip) {
      closeAll();
      return;
    }

    const section = tip.closest('.whats-inside');
    if (!section) return;

    // Touch / coarse pointers: tap to toggle. Fine pointers use hover.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    event.preventDefault();
    const willOpen = !tip.classList.contains('is-open');
    closeAll(tip);
    tip.classList.toggle('is-open', willOpen);
    if (willOpen) positionTooltip(tip);
  }

  function onKeyDown(event) {
    if (event.key === 'Escape') closeAll();
  }

  document.addEventListener('pointerover', onPointerOver);
  document.addEventListener('pointerout', onPointerOut);
  document.addEventListener('focusin', onFocusIn);
  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeyDown);
})();
